import React from 'react';

import { Icon } from '@chakra-ui/react';

export const CriticalDataIcon = props => {
  return (
    <Icon viewBox="0 0 404 404" h="full" w="full" color="inherit" {...props}>
      <g transform="translate(-433 -157)">
        <g>
          <g>
            <g>
              <path
                d="M179.149 282.146 280.984 303.14C280.984 303.14 425.872 302.259 429.944 303.14 434.017 304.022 537.448 282.146 537.448 282.146"
                stroke="currentColor"
                strokeWidth="27.992"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1 0 0 1.00009 278.018 2.08323)"
              />
              <path
                d="M292.615 215.805 280.984 303.098 355.457 500.792 429.944 301.237 418.314 215.805"
                stroke="currentColor"
                strokeWidth="27.992"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1 0 0 1.00009 278.018 2.08323)"
              />
              <path
                d="M423.982 471.555 537.448 282.146 486.824 215.805 229.773 215.805 179.149 282.146 292.615 471.555 355.457 500.792 423.982 471.555Z"
                stroke="currentColor"
                strokeWidth="27.992"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1 0 0 1.00009 278.018 2.08323)"
              />
            </g>
          </g>
        </g>
      </g>
    </Icon>
  );
};
